import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { HeaderComponent } from '../../header/header.component';

@Component({
  selector: 'app-contact-thank-you',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent
  ],
  templateUrl: './contact-thank-you.component.html',
  styleUrls: ['./contact-thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
  constructor(private titleService: Title) {
    this.titleService.setTitle("Thank you");
  }

  ngOnInit(): void {}

}
